import { Grid, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { Controller, useFormContext, useController } from 'react-hook-form';
import usePlacesAutocomplete, { getGeocode, getZipCode } from 'use-places-autocomplete';

export const AddressAutocomplete = (props) => {
    const { name, label, defaultValue } = props;
    const { meta } = useController(props);
    const [options, setOptions] = React.useState([]);
    const {
        suggestions: { data },
        setValue,
        clearSuggestions
    } = usePlacesAutocomplete({
        requestOptions: { componentRestrictions: { country: 'CA' }, debounce: 300 }
    });

    const methodes = useFormContext();
    const control = methodes.control;
    const errorText = meta.invalid ? 'Required' : '';
    const [valueOpt, setvalueOpt] = React.useState('');

    const handleInput = (e) => {
        setValue(e?.target?.value);
        let newOptions = [];
        if (valueOpt) {
            newOptions = [valueOpt];
        }
        if (data) {
            newOptions = [...data];
        }
        setOptions(newOptions);
        if (e?.target?.value === '') {
            clearSuggestions();
            setOptions([]);
        }
    };

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={({ ...props }) => (
                <Autocomplete
                    autoComplete
                    getOptionLabel={(option) =>
                        typeof option === 'string'
                            ? option
                            : option.structured_formatting?.main_text
                    }
                    {...props}
                    options={options}
                    filterOptions={(x) => x}
                    onInputChange={handleInput}
                    includeInputInList
                    freeSolo
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            variant="outlined"
                            fullWidth
                            size="small"
                            error={!!errorText}
                        />
                    )}
                    onChange={(event, newValue) => {
                        const { terms } = newValue || {};
                        const [city, province] = terms || [];
                        if (newValue) {
                            console.log(newValue);
                            const primaryName = name.substring(0, name.lastIndexOf('.'));
                            methodes.setValue(name, newValue.description);
                            getGeocode({ address: newValue.description })
                                .then((results) => getZipCode(results[0], false))
                                .then((postalCode) => {
                                    methodes.setValue(
                                        `${primaryName}.address.postalCode`,
                                        postalCode
                                    );
                                });
                            methodes.setValue(
                                `${primaryName}.address.location`,
                                newValue.structured_formatting.main_text
                            );
                            // check is province is defined in terms[3]
                            if (terms[3]?.value !== undefined && terms[3]?.value !== null) {
                                methodes.setValue(`${primaryName}.address.city`, terms[2]?.value);
                                methodes.setValue(`${primaryName}.address.province`, terms[3]?.value);
                            }
                            else {
                                methodes.setValue(`${primaryName}.address.city`, city?.value);
                                methodes.setValue(`${primaryName}.address.province`, province?.value);
                            }
                        }

                        setvalueOpt(newValue);
                        clearSuggestions();
                        setOptions([]);
                    }}
                    renderOption={(option) => {
                        return (
                            <Grid container alignItems="center">
                                <Grid item xs>
                                    <span style={{ fontWeight: 400 }}>
                                        {option.structured_formatting.main_text}
                                    </span>
                                    <Typography variant="body2" color="textSecondary">
                                        {option.structured_formatting.secondary_text}
                                    </Typography>
                                </Grid>
                            </Grid>
                        );
                    }}
                />
            )}
        />
    );
};
